import * as React from "react";
const SvgClose = props => <svg xmlns="http://www.w3.org/2000/svg" width={17} height={17} viewBox="0 0 17 17" {...props}><path fill="currentColor" d="M.519 15.073 15.572.02l1.32 1.32L1.839 16.393zM1.828.008l15.053 15.053-1.32 1.32L.508 1.328z" /></svg>;
export default SvgClose;